export const dumpExchangeData = (data) => {
  const { fields, parser } = data;

  let updatedFields = {};

  for (const field of fields) {
    updatedFields = {
      ...updatedFields,
      [field?.field]: field?.active,
    };
  }

  return {
    ...data,
    fields: updatedFields,
    parser: { ...parser, dynamic: parser?.dynamic ? 1 : 0 },
  };
};
